import React, { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { getUserDetails } from '../../services/authService';
import Orders from '../Orders/Orders'; // Placeholder for future implementation
import Subscriptions from '../Subscriptions/Subscriptions'; // Placeholder for future implementation
import Admin from '../Admin/Admin'; // Placeholder for future implementation
import AvailablePlants from '../Plant/AvailablePlants';
import AvailableSubscription from '../Subscriptions/AvailableSubscription';

function Dashboard() {
  const { logout } = useContext(AuthContext);
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('Orders');
  const [userDetails, setUserDetails] = useState({});

  useEffect(() => {
    getUserDetails()
      .then((response) => {
        // Set user first name in username
        setUsername(response.data.first_name);
        setUserDetails(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
        logout(); // Redirect to login if there's an error fetching user details
      });
  }, [logout]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen text-xl text-gray-300">
        Loading...
      </div>
    );
  }

  return (
    <div className="min-h-screen p-8 bg-gray-900">
      <div className="max-w-7xl mx-auto bg-gray-800 rounded-lg shadow p-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-white">Welcome, {username}</h1>
        </div>
        {/* Navigation Tabs */}
        <div className="mb-6 border-b border-gray-700">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => setActiveTab('Orders')}
              className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'Orders'
                  ? 'border-indigo-500 text-indigo-400'
                  : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-600'
              }`}
            >
              Orders
            </button>
            <button
              onClick={() => setActiveTab('Plants')}
              className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'Plants'
                  ? 'border-indigo-500 text-indigo-400'
                  : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-600'
              }`}
            >
              Plants
            </button>
            <button
              onClick={() => setActiveTab('Subscriptions')}
              className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'Subscriptions'
                  ? 'border-indigo-500 text-indigo-400'
                  : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-600'
              }`}
            >
              Subscriptions
            </button>
            {/* New tab for Admin, only visible when user has is_staff set to true */}
            {userDetails.is_staff && (
              <button
                onClick={() => setActiveTab('Admin')}
                className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'Admin'
                    ? 'border-indigo-500 text-indigo-400'
                    : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-600'
                }`}
              >
                Admin
              </button>
            )}
          </nav>
        </div>
        {/* Active Tab Content */}
        <div className="text-gray-300">
          {activeTab === 'Orders' && <Orders />}
          {activeTab === 'Plants' && <AvailablePlants />}
          {activeTab === 'Subscriptions' && <AvailableSubscription />}
          {activeTab === 'Admin' && <Admin />}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
